import { ChannelName } from '../../../learnware/LearnwareEnums';
export class IntentSettings {
    constructor(init = {}) {
        Object.assign(this, init);
    }
    playbackChannel = ChannelName.Voice;
    playbackAbortRunning = [];
    playbackAbortQueued = [];
    playbackAbortConditions = ['isAlreadyPlaying'];
    playbackStartConditions = [
        'isChannelFree_voice',
        'isChannelFree_sound',
        'isChannelFree_background',
        'isSilenceSince_0.5',
        'isSilenceSince_1',
        'isSilenceSince_2',
    ];
    playbackLoop = 0;
    playbackVolume = 1;
    playbackRate = 1;
    sequenceStartPosition;
    sequenceEndPosition;
    setSettings(settings = {}) {
        Object.assign(this, settings);
    }
    fromAspect(aspect) {
        [
            'playbackChannel',
            'playbackAbortRunning',
            'playbackAbortQueued',
            'playbackVolume',
            'playbackRate',
            'playbackLoop',
            'sequenceStartPosition',
            'sequenceEndPosition',
            'playbackAbortConditions',
            'playbackStartConditions',
        ].forEach(key => {
            if (aspect.activeOf[key]) {
                // console.log(`set ${key}`, aspect.valueOf[key]);
                this[key] = aspect.valueOf[key];
            }
        });
    }
}
